<template>
	<div class="device-alarm-page">
		<gc-header header-data="deviceAlarm" />
		<div class="content">
			<div class="operation-bar">
				<search-form @params-change="handleParamsChange" />
				<el-button v-click-blur class="btn" type="primary" @click="handleQueryClick">查 询</el-button>
				<el-button v-show="!editing" v-click-blur class="btn" type="primary" @click="handleCheckClick">
					批量勾选
				</el-button>
				<el-button v-show="!editing" v-click-blur class="btn" type="primary" @click="handleEditClick">
					编 辑
				</el-button>
				<el-button v-show="editing" v-click-blur class="cancel-btn" @click="handleCancelClick">取 消</el-button>
				<el-button v-show="editing" v-click-blur class="btn" type="primary" @click="handleConfirmClick">
					确 认
				</el-button>
			</div>
			<div class="table-wrapper" v-loading="loading">
				<gc-table
					ref="deviceTable"
					border
					showPage
					:total="total"
					:columns="columns"
					:table-data="tableData"
					:current-page.sync="currentPage"
					:page-size="pageSize"
					@current-page-change="pageChange"
					@size-change="handleSizeChange"
				>
					<template #eventLevel="{ index }">
						<el-select v-model="tableData[index].eventLevel" size="mini" :disabled="!editing">
							<el-option
								v-for="option in alarmLevelList"
								:key="option.value"
								:label="option.label"
								:value="option.value"
							></el-option>
						</el-select>
					</template>
					<template #eventSwitch="{ index }">
						<el-checkbox
							v-model="tableData[index].eventSwitch"
							true-label="1"
							false-label="0"
							:disabled="!editing"
						></el-checkbox>
					</template>
					<template #pushWechat="{ index }">
						<el-checkbox
							v-model="tableData[index].pushWechat"
							:true-label="SWITCH_STATUS.active"
							:false-label="SWITCH_STATUS.deactive"
							:disabled="!editing"
						></el-checkbox>
					</template>
					<template #pushSms="{ index }">
						<el-checkbox
							v-model="tableData[index].pushSms"
							:true-label="SWITCH_STATUS.active"
							:false-label="SWITCH_STATUS.deactive"
							:disabled="!editing"
						></el-checkbox>
					</template>
					<template #pushPage="{ index }">
						<el-checkbox
							v-model="tableData[index].pushPage"
							:true-label="SWITCH_STATUS.active"
							:false-label="SWITCH_STATUS.deactive"
							:disabled="!editing"
						></el-checkbox>
					</template>
					<template #pushVoice="{ index }">
						<el-checkbox
							v-model="tableData[index].pushVoice"
							:true-label="SWITCH_STATUS.active"
							:false-label="SWITCH_STATUS.deactive"
							:disabled="!editing"
						></el-checkbox>
					</template>
				</gc-table>
			</div>
		</div>
	</div>
</template>

<script>
import {
	apiGetDeviceAlarmConfig,
	apiBatchDeviceAlarmConfig,
	apiEditDeviceAlarmConfig,
} from '@/apis/waterAlarmConfig.api'
import SearchForm from './SearchForm.vue'
import { columns, eventSwitchObj } from './config'

const SWITCH_STATUS = {
	active: '1',
	deactive: '0',
}

export default {
	name: 'DeviceAlarm',
	components: {
		SearchForm,
	},
	data() {
		return {
			SWITCH_STATUS,
			loading: false,
			columns,
			total: 0,
			tableData: [],
			// 用于比较提取出修改了的数据项，以及回滚
			tableDataBackUp: [],
			currentPage: 1,
			pageSize: 20,
			editing: false,
			searchParams: {},
		}
	},
	computed: {
		alarmLevelList() {
			return (this.$store.getters.dataList.alarmLevel || []).map(item => ({
				label: item.name,
				value: item.defaultValue,
			}))
		},
	},
	activated() {
		this.getTableData({})
	},
	methods: {
		handleParamsChange(params) {
			this.searchParams = params
		},
		handleQueryClick() {
			this.currentPage = 1
			this.getTableData({ current: 1, ...this.searchParams })
		},
		handleCheckClick() {
			this.$confirm('是否勾选该页面所有的"报警启用状态"？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					this.checkAllAlaramStatus()
				})
				.catch(() => {})
		},
		handleEditClick() {
			this.tableDataBackUp = JSON.parse(JSON.stringify(this.tableData))
			this.editing = true
		},
		handleCancelClick() {
			this.editing = false
			this.refreshTable()
		},
		handleConfirmClick() {
			const editedTableData = this.extractEditedData(this.tableData, this.tableDataBackUp)
			const data = this.generateTableParams(editedTableData)
			this.updateTableData(data)
			this.editing = false
		},
		generateTableParams(tabelData) {
			return tabelData.map(item => {
				const pushTypeArray = ['pushWechat', 'pushSms', 'pushPage', 'pushVoice']
				return {
					eventModelConfigId: item.eventModelConfigId,
					eventLevel: item.eventLevel,
					eventSwitch: item.eventSwitch,
					pushCreateBIds: pushTypeArray
						.map((key, index) => (item[key] === SWITCH_STATUS.active ? index + 1 : undefined))
						.filter(item => item !== undefined)
						.join(','),
				}
			})
		},
		updateTableData(data) {
			this.loading = true
			Promise.allSettled(data.map(item => apiEditDeviceAlarmConfig(item)))
				.then(() => {
					this.$message.success('修改成功')
				})
				.finally(() => {
					this.loading = false
					this.refreshTable()
				})
		},
		checkAllAlaramStatus() {
			const params = this.generateBatCheckParams(this.tableData)
			this.loading = true
			apiBatchDeviceAlarmConfig(params)
				.then(() => {
					this.$message.success('勾选成功')
					this.refreshTable()
				})
				.catch(() => {})
				.finally(() => {
					this.loading = false
				})
		},
		pageChange(current) {
			this.currentPage = current
			this.getTableData({ current })
		},
		handleSizeChange(size) {
			this.pageSize = size
			this.currentPage = 1
			this.getTableData({ current: 1 })
		},
		refreshTable() {
			this.getTableData({ current: this.currentPage })
		},
		extractEditedData(newData, oldData) {
			return newData.filter((row, index) => {
				const oldRow = oldData[index]
				const compareArray = ['eventLevel', 'eventSwitch', 'pushWechat', 'pushSms', 'pushPage', 'pushVoice']
				return compareArray.some(key => row[key] !== oldRow[key])
			})
		},
		generateParams(params) {
			return {
				size: this.pageSize,
				current: this.currentPage,
				...this.searchParams,
				...params,
			}
		},
		generateBatCheckParams(tableData) {
			return tableData
				.filter(item => item.eventSwitch === String(eventSwitchObj.停用))
				.map(item => ({
					eventModelConfigId: item.eventModelConfigId,
					eventSwitch: String(eventSwitchObj.启用),
				}))
		},
		async getTableData(data) {
			const params = this.generateParams(data)

			const { tableData, total } = await this.queryTableData(params)
			this.tableData = tableData
			this.total = total
		},
		queryTableData(params) {
			this.loading = true
			return apiGetDeviceAlarmConfig(params)
				.then(res => {
					return {
						tableData: res.records.map((item, index) => ({ no: index + 1, ...item })),
						total: res.total,
					}
				})
				.catch(() => ({ tableData: [], total: 0 }))
				.finally(() => {
					this.loading = false
				})
		},
	},
}
</script>

<style scoped lang="scss">
.device-alarm-page {
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow: hidden;
}

.content {
	flex: 1;
	display: flex;
	flex-direction: column;
	padding: 20px 12px 0 12px;
	overflow: hidden;
}
.operation-bar {
	display: flex;
	flex-wrap: wrap;
}

.btn {
	&:nth-of-type(1) {
		margin-left: 20px;
	}

	&:nth-of-type(2) {
		margin-left: auto;
		margin-right: 10px;
	}
}

.cancel-btn {
	margin-left: auto;
}

.table-wrapper {
	flex: 1;
	padding-top: 10px;
	overflow: hidden;
}
</style>
